/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SetsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      sets: this.store.findAll('school-options/set'),
    });
  }
}
